import { render, staticRenderFns } from "./KarmaHistory.vue?vue&type=template&id=182e7b34&scoped=true&"
import script from "./KarmaHistory.vue?vue&type=script&lang=js&"
export * from "./KarmaHistory.vue?vue&type=script&lang=js&"
import style0 from "./KarmaHistory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaHistory.vue?vue&type=style&index=1&id=182e7b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e7b34",
  null
  
)

export default component.exports